// extracted by mini-css-extract-plugin
export var container = "styles-module__container___IV8Cy";
export var handle = "styles-module__handle___WrKwV";
export var image = "styles-module__image___YuKSK";
export var imageContainer = "styles-module__imageContainer___yr4zN";
export var title = "styles-module__title___r4cwi";